<template>
  <v-dialog persistent v-model="visible" transition="dialog-bottom-transition">
    <v-card color="#eeeeee">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="cerrar()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Pago de {{ titlePago }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn :disabled="!pagoCompleto" text @click="pagar()"> Pagar </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <Reservas
        v-model="reservas"
        :reservas="reservasActivas"
        @reservacion="seleccionaReservacion"
      />
      <Confirm
        :visible="confirm.visible"
        :text="confirm.text"
        :title="confirm.title"
        :aceptar-text="confirm.aceptarText"
        :cancelar-text="confirm.cancelarText"
        :event="confirm.event"
        @cancelar="confirm.visible = false"
        @aceptar="eliminarAceptado"
      />

      <!-- FORMULARIO PAGO A CREDITO -->
      <v-dialog
        v-model="dialogPagoCredito"
        width="600px"
        persistent
        :retain-focus="false"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialogPagoCredito = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Pago a Crédito</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="creditoForm.strNombre"
                    label="Nombre"
                    outlined
                    dense
                    append-outer-icon="mdi-account-search"
                    @click:append-outer="abrirAyudaClientes"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <!-- <v-text-field
              label="Clave"
              outlined
              dense
              readonly
              v-model="creditoForm.intClave"
            /> -->
                  <v-text-field
                    v-model="creditoForm.intClave"
                    label="Clave"
                    outlined
                    dense
                    append-outer-icon="mdi-account-search"
                    @click:append-outer="abrirAyudaClientesXClave"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-text-field
                    label="Estatus"
                    outlined
                    dense
                    v-model="creditoForm.strGiroComercial"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-text-field
                    label="Telefono"
                    outlined
                    dense
                    v-model="creditoForm.strTelefono"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-text-field
                    label="Se envia a:"
                    outlined
                    dense
                    v-model="creditoForm.strEmail"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-text-field
                    label="Monto"
                    type="number"
                    outlined
                    dense
                    readonly
                    v-model="credito.monto"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-text-field
                    label="Saldo"
                    type="number"
                    outlined
                    dense
                    readonly
                    v-model="creditoForm.dblSaldo"
                  />
                </v-col>
              </v-row>

              <v-text-field type="hidden" v-model="creditoForm.intCliente" />

              <v-text-field type="hidden" v-model="creditoForm.intContacto" />

              <v-row>
                <v-col>
                  <v-text-field
                    label="Fecha"
                    outlined
                    dense
                    readonly
                    :value="fechaCreditoHoy"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-btn color="red" outlined small @click="nuevoCliente">
                    <v-icon left>mdi-close</v-icon>
                    Nuevo Cliente
                  </v-btn>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <img
                    :src="creditoForm.strImagen"
                    alt="Cliente"
                    style="max-width:500px"
                    @error="onImgError"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-text-field
                    v-model="contactoForm.strNombre"
                    label="Contactos"
                    outlined
                    dense
                    append-outer-icon="mdi-account-search"
                    @click:append-outer="abrirAyudaContactos"
                  />
                </v-col>
              </v-row>
              <v-row v-if="contactoFormVista">
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="contactoForm.strTelefono"
                    label="Teléfono"
                    outlined
                    dense
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    label="Email"
                    outlined
                    dense
                    readonly
                    v-model="contactoForm.strEmail"
                  />
                </v-col>

                <v-col cols="12">
                  <img
                    :src="contactoForm.strImagen"
                    alt="Logo contacto"
                    style="max-width:500px"
                    @error="onImgError"
                  />
                </v-col>
                <v-row>
                  <v-col>
                    <v-btn color="red" outlined small @click="cerrarContacto">
                      <v-icon left>mdi-close</v-icon>
                      Quitar contacto
                    </v-btn>
                  </v-col>
                </v-row>
              </v-row>
            </v-container>
          </v-card-text>

          <v-row v-if="dialogPagoCredito">
            <v-col>
              <label class="font-weight-medium mb-2 d-block">
                Firma del cliente
              </label>

              <canvas ref="firmaCanvas" class="firma-canvas"></canvas>

              <v-btn small outlined class="mt-2" @click="limpiarFirma">
                Limpiar firma
              </v-btn>
            </v-col>
          </v-row>

          <v-card-actions>
            <v-spacer />
            <v-btn text @click="dialogPagoCredito = false">Cancelar</v-btn>
            <v-btn color="primary" @click="guardarCredito">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dlgClientes" max-width="900">
        <v-card>
          <v-card-title>
            Clientes
            <v-spacer />
            <v-btn icon @click="dlgClientes = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-data-table
              :headers="headersClientes"
              :items="clientes"
              dense
              @click:row="seleccionarCliente"
            />
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dlgContactos" max-width="900">
        <v-card>
          <v-card-title>
            Contactos
            <v-spacer />
            <v-btn icon @click="dlgContactos = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-data-table
              :headers="headersContactos"
              :items="contacto"
              dense
              @click:row="seleccionarContacto"
            />
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog width="500px" v-model="envio_correo.visible">
        <v-card>
          <v-toolbar dark color="dark">
            <v-btn rounded icon dark @click="envio_correo.visible = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Envio de Ticket Electronico</v-toolbar-title>
          </v-toolbar>
          <v-card outlined>
            <v-container fluid>
              <v-row>
                <v-col>
                  <v-text-field
                    rounded
                    label="Correo"
                    v-model="correo"
                    placeholder="fulanito@ejemplo.com"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn rounded block color="primary" @click="enviarcorreo()"
                    >ENVIAR</v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn rounded block color="success" @click="pagar2()"
                    >PAGAR</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogCoDi" max-width="500" persistent>
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Pago CoDi</v-toolbar-title>
          </v-toolbar>

          <v-card-text class="text-center">
            <p>Escanee el código QR con su aplicación bancaria</p>

            <qrcode-vue :value="qrValue" :size="300" />

            <v-divider class="my-4"></v-divider>
            <div class="text-subtitle-1 font-weight-bold">
              Monto: {{ toMoney(cantidad) }}
            </div>
            <div class="text-body-2">
              Referencia: {{ localValue.intPOSEnc }}
            </div>
            <div class="text-body-2">
              Concepto: Venta {{ localValue.intPOSEnc }}
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="dialogCoDi = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col md="4">
              <v-card min-height="100%" hover class="rounded-xl" elevation="50">
                <v-card-title>Totales {{ titlePago }}</v-card-title>
                <v-card-text>
                  <v-container class="font-weight-black" fluid>
                    <v-row no-gutters>
                      <v-col>SubTotal</v-col>
                      <v-col>{{ toMoney(localValue.dblSubtotal) }}</v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>IVA</v-col>
                      <v-col>{{ toMoney(localValue.dblIVA) }}</v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>ISH</v-col>
                      <v-col>{{ toMoney(localValue.dblISH) }}</v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>Envio</v-col>
                      <v-col>{{ toMoney(localValue.dblEnvio1) }}</v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>Descuento</v-col>
                      <v-col
                        >({{ toMoney(localValue.dblImporteDescuento) }})</v-col
                      >
                    </v-row>
                    <v-row no-gutters>
                      <v-col>Total a Pagar</v-col>
                      <v-col>{{ toMoney(totalOrden) }}</v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <v-card
                min-height="100%"
                hover
                class="rounded-xl"
                elevation="50"
                v-show="disabled"
              >
                <v-card-title>Propina</v-card-title>
                <v-card-text>
                  <v-container fluid>
                    <v-row no-gutters>
                      <v-col>
                        <v-text-field
                          dense
                          rounded
                          min="0"
                          type="number"
                          outlined
                          @keypress="isNumber($event)"
                          prefix="%"
                          v-model="propinaPorcentaje"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>
                        <v-text-field
                          rounded
                          dense
                          min="0"
                          type="number"
                          outlined
                          @keypress="isFloat($event)"
                          prefix="$"
                          v-model="propina"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col md="4">
              <v-card min-height="100%" hover class="rounded-xl" elevation="50">
                <v-card-title> Informacion Pago </v-card-title>
                <v-card-text>
                  <v-container class="font-weight-black" fluid>
                    <v-row no-gutters>
                      <v-col>Total</v-col>
                      <v-col>{{ toMoney(totalOrden) }}</v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>Pago</v-col>
                      <v-col>{{ toMoney(pagado) }}</v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>Cambio</v-col>
                      <v-col>{{ toMoney(cambio) }}</v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <!-- <v-row >
            <input class="FacCheck"   type="checkbox" v-model="requiere_factura" id="factura-checkbox">
            <label class="FacLab"  for="checkbox">  Solicitar Factura</label>
          </v-row> -->
          <v-row v-if="false">
            <input
              class="FacCheck"
              type="checkbox"
              v-model="requiere_factura"
              id="factura-checkbox"
            />
            <label class="FacLab" for="factura-checkbox"
              >Solicitar Factura</label
            >
          </v-row>

          <v-row>
            <v-col :key="tipoPago.strNombre" v-for="tipoPago in tiposPagos">
              <v-btn
                :color="tipoPago == pagoSeleccionado ? 'secondary' : 'primary'"
                rounded
                light
                block
                @click="seleccionarPago(tipoPago)"
              >
                <!-- <v-icon left dark v-text="get_icon(tipoPago.strNombre)"></v-icon> -->
                <v-icon left dark>
                  {{ get_icon(tipoPago.strNombre) }}
                </v-icon>
                {{ tipoPago.strNombre }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="pagos != []">
            <v-col md="4" :key="index" v-for="(pago, index) in pagos">
              <v-card min-height="100%" hover class="rounded-xl" elevation="50">
                <v-card-title>
                  <v-toolbar flat>
                    <v-toolbar-title
                      >{{ pago.tipoPago.strNombre }}
                      {{ pago.referencia }}</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-btn icon @click="eliminar(pago, index)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                </v-card-title>
                <v-card-text class="text-center">
                  <h2>{{ toMoney(pago.cantidad) }}</h2>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="pagoSeleccionado != null">
            <v-col>
              <v-text-field
                dense
                rounded
                :label="pagoSeleccionado.strNombre"
                min="0"
                type="number"
                outlined
                @keypress="isFloat($event)"
                prefix="$"
                ref="cantidad"
                v-model="cantidad"
              ></v-text-field>
            </v-col>
            <v-col v-if="btnReferencia">
              <v-btn rounded color="primary" block @click="verReservas()"
                >Ver Reservaciones</v-btn
              >
            </v-col>
            <v-col v-if="mostrar_concepto">
              <v-text-field
                rounded
                dense
                label="Concepto"
                outlined
                ref="Concepto"
                v-model="strConceptoTransaccion"
              ></v-text-field>
            </v-col>
            <v-col v-if="intPOSReferencia == 1">
              <v-text-field
                rounded
                dense
                label="Referencia"
                outlined
                ref="referencia"
                v-model="referencia"
              ></v-text-field>
            </v-col>
            <v-col v-if="mostrar_terminales">
              <v-select
                dense
                rounded
                ref="terminalpago"
                :items="terminalespago"
                outlined
                item-text="strNombre"
                item-value="intPOSTerminalPago"
                label="Terminal"
                v-model="terminal_seleccionada"
              >
              </v-select>
            </v-col>
            <v-col>
              <v-btn rounded color="primary" dark block @click="guardarPago()"
                >Guardar Pago</v-btn
              >
            </v-col>
          </v-row>
          <v-row v-if="mostrar_prosepago">
            <v-col md="4">
              <v-text-field
                rounded
                dense
                label="Nombre"
                outlined
                ref="nombre"
                v-model="referencia"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                rounded
                dense
                label="Correo Electronico"
                outlined
                ref="email"
                v-model="correo"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { isNumber, isMoney, isFloat } from "../js/utilities";
import Confirm from "./ConfirmComponent.vue";
import Reservas from "./ReservasActivasComponent.vue";
import QrcodeVue from "qrcode.vue";

import {
  Toast,
  Session,
  Data,
  ErrorWeb,
} from "../controllers/DataController.js";
import {
  POSEncPagoFunctions,
  POSEncFunctions,
} from "../controllers/POSController.js";
import Cookies from "js-cookie";
import axios from "axios";

var math = require("mathjs");
var Decimal = require("decimal.js");

export default {
  props: {
    value: {
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    terminalespago: {
      type: Array,
      default: () => [],
    },
    tipospago: {
      type: Array,
      default: () => [],
    },
    envio: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Confirm,
    Reservas,
    QrcodeVue,
  },
  data() {
    return {
      qrValue: "",
      dialogCoDi: false,
      tipoPagoControl: 0,
      //saldoList: [],
      ctx: null,
      dibujando: false,
      signaturePad: null,
      dlgClientes: false,
      dlgContactos: false,
      contactoFormVista: false,
      clientes: [],
      contacto: [],
      headersClientes: [
        { text: "Telefono", value: "strTelefono" },
        { text: "Nombre", value: "strNombre" },
        { text: "Dirección", value: "strDireccion" },
        //{ text: 'Clave', value: 'intClave' },
        { text: "Estatus", value: "strGiroComercial" },
        //{ text: 'Saldo', value: 'dblSaldo' },
        { text: "Email", value: "strEmail" },
        //{ text: 'Contacto', value: 'intContacto' },
        { text: "Cliente", value: "intCliente" },
        // ,
        // { text: 'Foto', value: 'strImagen' }
      ],
      headersContactos: [
        { text: "Telefono", value: "strTelefono" },
        { text: "Nombre", value: "strNombre" },
        //{ text: 'Dirección', value: 'strDireccion' },
        { text: "Email", value: "strEmail" },
        { text: "Contacto", value: "intContacto" },
        // ,
        // { text: 'Foto Contacto', value: 'strImagen' }
      ],
      mostrarFactura: false,
      requiere_factura: false,
      mostrar_prosepago: false,
      loading: false,
      localValue: this.value,

      contactoForm: {
        intContacto: 0,
        strNombre: "",
        strTelefono: "",
        strEmail: "",
        strImagen: null,
      },
      contactoFormDefault: {
        intContacto: 0,
        strNombre: "",
        strTelefono: "",
        strEmail: "",
        strImagen: null,
      },
      creditoForm: {
        fecha: null,
        monto: 0,
        intClave: null,
        strGiroComercial: "",
        strNombre: "",
        strTelefono: "",
        strEmail: "",
        dblSaldo: 0,
        intCliente: 0,
        intContacto: 0,
        strImagen: null,
      },
      creditoFormDefault: {
        fecha: null,
        monto: 0,
        intClave: null,
        strGiroComercial: "",
        strNombre: "",
        strTelefono: "",
        strEmail: "",
        dblSaldo: 0,
        intCliente: 0,
        intContacto: 0,
        strImagen: null,
      },
      session: new Session(),
      POSEnc: this.pago,
      pagoFunctions: new POSEncPagoFunctions(this.$config.api_backend_route),
      encFunctions: new POSEncFunctions(this.$config.api_backend_route),
      facturacion: false,
      //requiere_factura: false,
      facturacionModal: {
        visible: true,
      },
      correo: "sincorreo@gmail.com",
      envio_correo: {
        visible: false,
      },

      dialogPagoCredito: false,
      menuFechaCredito: false,

      credito: {
        cliente: "",
        referencia: "",
        telefono: "",
        monto: null,
        fechaCredito: null,
      },
      confirm: {
        visible: false,
        text: "",
        title: "¿Desea eliminar el registro?",
        aceptarText: "Aceptar",
        cancelarText: "Cancelar",
        event: "confirm",
      },
      reservas: {
        visible: false,
      },
      reservasActivas: [],
      tiposPagos: [],
      pagoSeleccionado: null,
      pagos: () => [],
      cantidad: 0.0,
      indexSeleccionado: 0,
      referencia: "",
      intPOSReferencia: 0,
      propina: 0,
      propinaPorcentaje: 0,
      reservacion: 0,
      referenciaDisabled: false,
      btnReferencia: false,
      mostrar_terminales: false,
      terminal_seleccionada: null,
      disabled: true,
      total: 0,
      strConceptoTransaccion: "",
      mostrar_concepto: false,
      titlePago: this.$config.ordenTitle,
      config_21: this.$config.opciones.find((c) => c.id == 21),
    };
  },
  computed: {
    faltante() {
      console.log(
        "Faltante",
        math.round(
          math
            .chain(this.totalOrden)
            .subtract(this.pagado)
            .done(),
          2
        )
      );
      return math.round(
        math
          .chain(this.totalOrden)
          .subtract(this.pagado)
          .done(),
        2
      );
    },
    fechaCreditoHoy() {
      const hoy = new Date();
      return hoy.toISOString().substr(0, 10); // YYYY-MM-DD
    },

    totalDescuento() {
      return this.localValue.posDet.reduce((a, b) => {
        return a + (b.dblPU * b.dblCantidad * b.dblPorcentajeDescuento) / 100;
      }, 0);
    },
    detalles() {
      return this.localValue.posDet.filter(
        (detalle) => detalle.intEstatus != 8 && detalle.intEstatus != 9
      );
    },

    // total() {
    //   if (this.detalles.length > 0) {
    //     return this.detalles.reduce((a, b) => {
    //       console.log(b.dblTotal)
    //       let total= math.chain(a).add(math.round(b.dblTotal, 2)).done()
    //       return math.round(total,2)
    //     }, 0);
    //   } else {
    //     return 0.0;
    //   }
    // },
    // totalOrden() {
    //   //Se le agrega envio
    //   let total = math.round(this.localValue.dblTotal, 2);
    //   let propina = math.round(this.propina, 2);
    
    //   let orden = math
    //     .chain(total)
    //     .add(propina)
    //     .done();
    //   return math.round(orden, 2);
    // },
    totalOrden() {
  let total = math.round(this.localValue.dblTotal || 0, 2);
  let propina = math.round(this.propina || 0, 2);

  // console.log("===== CALCULO TOTAL =====");
  // console.log("localValue:", this.localValue);
  // console.log("dblTotal:", total);
  // console.log("dblSubtotal:", this.localValue.dblSubtotal);
  // console.log("dblEnvio1:", this.localValue.dblEnvio1);
  // console.log("propina:", propina);

  let orden = math
    .chain(total)
    .add(propina)
    .done();

  // console.log("TOTAL FINAL:", math.round(orden, 2));
  // console.log("=========================");

  return math.round(orden, 2);
},
   
    pagoCompleto() {
      let x = math.round(this.cambio, 2);
      const cambio = new Decimal(x);
      return cambio.greaterThanOrEqualTo(0.0);
    },
    cambio() {
      let pagado = math.round(this.pagado, 2);
      let total = math.round(this.localValue.dblTotal, 2);
      let propina = math.round(this.propina, 2);

      let cambio = math
        .chain(pagado)
        .subtract(total)
        .subtract(propina)
        .done();
      return math.round(cambio, 2);
    },
    pagado() {
      if (this.pagos.length > 0) {
        return this.pagos.reduce((a, b) => {
          let a2 = math.round(a, 2);
          let cantidad = math.round(b.cantidad, 2);
          return math.round(
            math
              .chain(a2)
              .add(cantidad)
              .done(),
            2
          );
        }, 0);
      } else {
        return 0;
      }
    },
  },
  watch: {
    dialogPagoCredito(val) {
      if (val === false) {
        this.creditoForm = { ...this.creditoFormDefault };
        this.contactoForm = { ...this.contactoFormDefault };
        this.limpiarEventListeners();
      }

      if (val) {
        // Pequeño delay para asegurar que el DOM esté renderizado
        setTimeout(() => {
          this.inicializarFirma();
        }, 100);
      }
    },
    pagos: {
      deep: true, // Para detectar cambios en objetos anidados
      handler() {
        const tieneTipoPago5000 = this.pagos.some(
          (p) => p.tipoPago && p.tipoPago.intTipoPago === 5000
        );
        this.tipoPagoControl = tieneTipoPago5000 ? 5000 : 0;
      },
    },
    loading: {
      handler(newValue) {
        this.$emit("loading", newValue);
      },
      deep: true,
    },
    value: {
      handler(newValue) {
        this.localValue = newValue;
      },
      deep: true,
    },
    propinaPorcentaje: {
      handler(value) {
        let subtotal = math.round(this.localValue.dblSubtotal, 2);
        let x = math.round(value, 2);
        let propina = math
          .chain(subtotal)
          .multiply(x)
          .divide(100)
          .done();
        this.propina = math.round(propina, 2);
      },
      deep: true,
    },
    localValue: {
      handler(newValue) {
        this.pagoSeleccionado = null;
        this.pagos = [];
        this.cantidad = 0.0;
        this.indexSeleccionado = 0;
        this.referencia = "";
        this.reservacion = 0;
        this.terminal_seleccionada = null;
        this.intPOSReferencia = 0;
        this.propina = this.localValue.dblPropina;
        this.propinaPorcentaje = 0;
        this.mostrar_prosepago = false;
        this.correo = "sincorreo@gmail.com";
        this.strConceptoTransaccion = "";
        this.mostrar_concepto = false;

        this.$emit("input", newValue);
      },
      deep: true,
    },
    // Nuevo watch para intPOSTipoVenta
    "localValue.intPOSTipoVenta": {
      handler(newValue) {
        // Llama a la función para obtener los tipos de pago en base a intPOSTipoVenta
        this.obtenerTiposPago(newValue);
      },
      immediate: true, // Si deseas que la función se ejecute inmediatamente al cargar
    },
  },
  methods: {
    isNumber: isNumber,
    isFloat: isFloat,
    toMoney: isMoney,
    async generarCoDi() {
      try {
        this.loading = true;

        const payload = {
          company: "TERPAY",
          account: "646180525200000009",
          amount: this.cantidad,
          concept: `Venta ${this.localValue.intPOSEnc}`,
          numeric_reference: this.localValue.intPOSEnc,
          payment_type: 20,
          user: Cookies.get("POS_USER"),
        };
      
        //const response = await axios.post("Servicios/GenerarCoDi", payload);
        const response = await axios.post("CoDi/Generar", payload);
        console.log(response.data);

        const codi = JSON.parse(response.data.content);
        console.log(JSON.stringify(codi.response, null, 2));

        console.log(codi);
        this.qrValue = JSON.stringify(codi.response);

        this.dialogCoDi = true;
      } catch (e) {     
        console.error(e);
        this.$toast.error("Error al generar CoDi");
      } finally {
        this.loading = false;
      }
    },
    getColor(tipoPago) {
      if (this.pagoSeleccionado == null) {
        return "red";
      } else if (tipoPago.strNombre == this.pagoSeleccionado.strNombre) {
        return "green";
      } else {
        return "red";
      }
    },
    get_icon(pago) {
      if (pago.substring(0, 2) == "04" || pago.substring(0, 2) == "28") {
        return "mdi-credit-card";
      } else if (pago.substring(0, 2) == "01") {
        return "mdi-cash";
      } else if (pago == "99-CARGO HABITACION") {
        return "mdi-seat-individual-suite";
      } else {
        return "mdi-alert-circle-outline";
      }
    },

    seleccionarPago(tipopago) {
      try {
        const totalPago = math.chain(this.cantidad).add(this.pagado);

        console.log("El tipo pago es:", tipopago);
        console.log("El tipo pago es:" + tipopago.intTipoPago);

        //Solo pagos en efectivo pueden exceder
        if (totalPago > this.totalOrden) {
          throw "Verifique su pago a agregar, no puede superar el total de la orden, " +
            this.toMoney(this.totalOrden);
        }

        // if (this.tipoPagoControl === 5000)
        //   {
        //     this.credito.monto = this.totalOrden;
        //     this.dialogPagoCredito = true;
        //     return;
        //   }

        if (this.pagoSeleccionado == null) {
          this.pagoSeleccionado = tipopago;
          this.intPOSReferencia = this.pagoSeleccionado.intPOSReferencia;
          //Asignamos el faltante al importe
          //Si es domicilio ya tenemos la cantidad que paga con
          if (
            this.localValue.intPOSTipoServicio == 2 &&
            this.config_21.valor == false
          ) {
            this.cantidad = this.localValue.dblPagaCon;
          } else {
            this.cantidad = this.faltante;
          }

          this.mostrar_terminales =
            this.pagoSeleccionado.strNombre.substring(0, 2) == "04" ||
            this.pagoSeleccionado.strNombre.substring(0, 2) == "28";

          this.mostrar_prosepago =
            this.pagoSeleccionado.strNombre == "04-PROSEPAGO";

          if (this.pagoSeleccionado.strNombre == "99-CARGO HABITACION") {
            this.referenciaDisabled = true;
            this.btnReferencia = true;
          } else {
            this.referenciaDisabled = false;
            this.btnReferencia = false;
          }
          this.mostrar_concepto =
            this.pagoSeleccionado.strNombre.substring(0, 2) == "03";
        } else if (this.pagoSeleccionado.strNombre == tipopago.strNombre) {
          this.pagoSeleccionado = null;
          this.mostrar_terminales = false;
          this.mostrar_prosepago = false;
          this.correo = "sincorreo@gmail.com";
          this.referencia = null;
          this.referencia = "";
          this.intPOSReferencia = 0;
          this.terminal_seleccionada = null;
          this.mostrar_concepto = false;
          this.strConceptoTransaccion = "";
        }
        //this.$refs.cantidad.focus();
      } catch (e) {
        this.$toast.error(e, new Toast());
      }
    },

    async abrirAyudaClientes() {
      this.loading = true;
      try {
        console.log("NOMBRE: " + this.creditoForm.strNombre);
        this.clientes = await this.encFunctions.clientesXnombre(
          this.creditoForm.strNombre?.trim() || null
        );
        console.log(this.clientes);
        this.dlgClientes = true;
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },

    async abrirAyudaClientesXClave() {
      this.loading = true;
      try {
        console.log("CLAVE: " + this.creditoForm.intClave);
        this.clientes = await this.encFunctions.clientesXclave(
          this.creditoForm.intClave
        );
        console.log(this.clientes);
        this.dlgClientes = true;
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },

    async abrirAyudaContactos() {
      this.loading = true;
      try {
        if (
          this.creditoForm.intCliente == null ||
          this.creditoForm.intCliente == ""
        ) {
          this.$toast.error("No se a seleccionado cliente");
          this.loading = false;
          return;
        }
        console.log("CLAVE: " + this.creditoForm.intCliente);
        this.contacto = await this.encFunctions.contactos(
          this.creditoForm.intCliente
        );
        console.log(this.contacto);
        this.dlgContactos = true;
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },

    async contactos(intCliente) {
      const session = new Session();

      const response = await axios.get("POS_DataContactos", {
        headers: session,
        params: {
          intCliente: intCliente,
        },
      });

      console.log("AXIOS RESPONSE:", response);
      console.log("DATA:", response.data);

      return response.data;
    },

    async clientesXclave(intClave) {
      const session = new Session();

      const response = await axios.get("POS_DataClientesXClave", {
        headers: session,
        params: {
          intClave: intClave,
        },
      });

      console.log("AXIOS RESPONSE:", response);
      console.log("DATA:", response.data);

      return response.data;
    },

    async clientesXnombre(strNombre) {
      const session = new Session();

      const response = await axios.get("POS_DataClientesXNombre", {
        headers: session,
        params: {
          strNombre: strNombre,
        },
      });

      console.log("AXIOS RESPONSE:", response);
      console.log("DATA:", response.data);

      return response.data;
    },

    onImgError(e) {
      e.target.src = "/images/nofoto.png";
      console.log("ENTRO EN ERROR DE IMAGEN " + e.target.src);
    },

    cerrarContacto() {
      this.contactoFormVista = false;

      // Resetear formulario (CLON para no romper la referencia)
      this.contactoForm = { ...this.contactoFormDefault };

      // Opcional: también limpiar el crédito
      this.creditoForm.intContacto = 0;
    },

    nuevoCliente() {
      this.contactoFormVista = false;

      // Resetear formulario (CLON para no romper la referencia)
      this.contactoForm = { ...this.contactoFormDefault };
      this.creditoForm = { ...this.creditoFormDefault };
      // Opcional: también limpiar el crédito
      this.creditoForm.intContacto = 0;
      this.creditoForm.intCliente = 0;
    },

    async seleccionarCliente(cliente) {
      this.creditoForm.strNombre = cliente.strNombre;
      this.creditoForm.strTelefono = cliente.strTelefono;
      this.creditoForm.intClave = cliente.intFolio;
      this.creditoForm.strDireccion = cliente.strDireccion;
      this.creditoForm.strEmail = cliente.strEmail;
      this.creditoForm.strGiroComercial = cliente.strGiroComercial;
      this.creditoForm.intCliente = cliente.intCliente;
      this.creditoForm.intContacto = cliente.intContacto;
      const DEFAULT_IMG = "/images/nofoto.png";

      this.creditoForm.strImagen = cliente.strImagen || DEFAULT_IMG;

      console.log("IMAGEN:", this.creditoForm.strImagen);
      var saldoList = await this.encFunctions.getSaldo(cliente.intCliente);
      console.log(saldoList);
      if (saldoList.dblTotal > 0) {
        this.creditoForm.dblSaldo = 0 ?? -350;
      } else {
        this.creditoForm.dblSaldo = saldoList.dblTotal ?? -350;
        // this.localValue.dblSubtotal = 0;
        // this.localValue.dblTotal = 0;
        // this.cantidad = 0;
      }
      this.dlgClientes = false;
    },

    async seleccionarContacto(contacto) {
      this.contactoFormVista = true;
      this.contactoForm.strNombre = contacto.strNombre;
      this.contactoForm.strTelefono = contacto.strTelefono;
      this.creditoForm.intContacto = contacto.intContacto;
      this.contactoForm.strEmail = contacto.strEmail;
      this.contactoForm.intContacto = contacto.intContacto;
      const DEFAULT_IMG = "/images/nofoto.png";

      this.contactoForm.strImagen = contacto.strImagen || DEFAULT_IMG;

      console.log("IMAGEN:", this.contactoForm.strImagen);

      console.log(contacto);
      console.log(this.contactoForm);
      console.log(this.creditoForm);
      this.dlgContactos = false;
    },

    inicializarFirma() {
      const canvas = this.$refs.firmaCanvas;
      if (!canvas) {
        console.error("Canvas no encontrado");
        return;
      }

      // Limpiar event listeners previos si existen
      this.limpiarEventListeners();

      const rect = canvas.getBoundingClientRect();
      const ratio = Math.max(window.devicePixelRatio || 1, 1);

      // Establecer tamaño real del canvas
      canvas.width = rect.width * ratio;
      canvas.height = rect.height * ratio;

      this.ctx = canvas.getContext("2d");
      this.ctx.scale(ratio, ratio);
      this.ctx.lineWidth = 2;
      this.ctx.lineCap = "round";
      this.ctx.strokeStyle = "#000";
      this.ctx.fillStyle = "white";
      this.ctx.fillRect(0, 0, canvas.width / ratio, canvas.height / ratio);

      // Guardar referencias a las funciones bindeadas
      this._inicioDibujo = this.inicioDibujo.bind(this);
      this._dibujar = this.dibujar.bind(this);
      this._finDibujo = this.finDibujo.bind(this);

      // Mouse events
      canvas.addEventListener("mousedown", this._inicioDibujo);
      canvas.addEventListener("mousemove", this._dibujar);
      canvas.addEventListener("mouseup", this._finDibujo);
      canvas.addEventListener("mouseleave", this._finDibujo);

      // Touch events
      canvas.addEventListener("touchstart", this._inicioDibujo);
      canvas.addEventListener("touchmove", this._dibujar);
      canvas.addEventListener("touchend", this._finDibujo);

      // Para prevenir scroll en móviles mientras se dibuja
      canvas.addEventListener(
        "touchmove",
        (e) => {
          if (this.dibujando) e.preventDefault();
        },
        { passive: false }
      );
    },

    limpiarEventListeners() {
      const canvas = this.$refs.firmaCanvas;
      if (!canvas) return;

      // Remover event listeners si existen
      if (this._inicioDibujo) {
        canvas.removeEventListener("mousedown", this._inicioDibujo);
        canvas.removeEventListener("touchstart", this._inicioDibujo);
      }
      if (this._dibujar) {
        canvas.removeEventListener("mousemove", this._dibujar);
        canvas.removeEventListener("touchmove", this._dibujar);
      }
      if (this._finDibujo) {
        canvas.removeEventListener("mouseup", this._finDibujo);
        canvas.removeEventListener("mouseleave", this._finDibujo);
        canvas.removeEventListener("touchend", this._finDibujo);
      }
    },
    inicioDibujo(e) {
      e.preventDefault();
      this.dibujando = true;

      const { x, y } = this.obtenerPosicion(e);
      this.ctx.beginPath();
      this.ctx.moveTo(x, y);
    },

    dibujar(e) {
      if (!this.dibujando) return;
      e.preventDefault();

      const { x, y } = this.obtenerPosicion(e);
      this.ctx.lineTo(x, y);
      this.ctx.stroke();
    },

    finDibujo() {
      this.dibujando = false;
    },

    obtenerPosicion(e) {
      const canvas = this.$refs.firmaCanvas;
      if (!canvas) return { x: 0, y: 0 };

      const rect = canvas.getBoundingClientRect();
      const ratio = Math.max(window.devicePixelRatio || 1, 1);

      let clientX, clientY;

      if (e.touches && e.touches[0]) {
        clientX = e.touches[0].clientX;
        clientY = e.touches[0].clientY;
      } else {
        clientX = e.clientX;
        clientY = e.clientY;
      }

      // Calcular posición relativa y ajustar por el ratio
      return {
        x: (clientX - rect.left) * (canvas.width / rect.width / ratio),
        y: (clientY - rect.top) * (canvas.height / rect.height / ratio),
      };

      // O esta alternativa más simple:
      // return {
      //   x: (clientX - rect.left) * (canvas.width / (rect.width * ratio)),
      //   y: (clientY - rect.top) * (canvas.height / (rect.height * ratio))
      // };
    },

    limpiarFirma() {
      const canvas = this.$refs.firmaCanvas;
      if (!canvas || !this.ctx) return;

      const rect = canvas.getBoundingClientRect();
      //const ratio = Math.max(window.devicePixelRatio || 1, 1);

      // Usar dimensiones reales del canvas
      this.ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Restaurar fondo blanco usando dimensiones reales
      this.ctx.fillStyle = "white";
      this.ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Opcional: Redibujar borde o guías
      this.ctx.strokeStyle = "#ddd";
      this.ctx.strokeRect(0, 0, rect.width, rect.height);

      // Restaurar configuración de dibujo
      this.ctx.lineWidth = 2;
      this.ctx.lineCap = "round";
      this.ctx.strokeStyle = "#000";
    },
    beforeDestroy() {
      this.limpiarEventListeners();
    },
    obtenerFirma() {
      const canvas = this.$refs.firmaCanvas;
      return canvas.toDataURL("image/png");
    },

    async guardarFirmaEnServidor(firmaBase64) {
      try {
        const nombreArchivo = this.generarNombreFirma();

        const firmaData = {
          ImagenBase64: firmaBase64,
          NombreArchivo: nombreArchivo,
          Cliente: this.creditoForm.strNombre || "",
          ClienteId: this.creditoForm.intCliente || 0,
          OrdenId: this.localValue.intPOSEnc || 0,
          Timestamp: new Date().toISOString(),
        };

        console.log("Enviando firma a API/GuardarFirma...");

        // Usa la ruta de tu controlador POS
        const response = await axios.post("GuardarFirma", firmaData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token") || ""}`,
          },
        });

        if (response.data && response.data.success) {
          console.log("✅ Firma guardada:", response.data.nombreArchivo);
          return {
            success: true,
            nombreArchivo: response.data.nombreArchivo,
            ruta: response.data.ruta,
          };
        } else {
          throw new Error(response.data?.error || "Error al guardar firma");
        }
      } catch (error) {
        console.error("❌ Error al guardar firma:", error);
        return {
          success: false,
          error: error.message,
          nombreArchivo: this.generarNombreFirma(),
        };
      }
    },

    // Método alternativo usando FormData
    async guardarFirmaFormData(firmaBase64) {
      const nombreArchivo = this.generarNombreFirma();

      // Convertir base64 a Blob
      const blob = this.base64ToBlob(firmaBase64, "image/png");
      const formData = new FormData();

      formData.append("firma", blob, nombreArchivo);
      formData.append("cliente", this.creditoForm.strNombre || "");
      formData.append("ordenId", this.localValue.intPOSEnc || 0);

      const response = await axios.post("GuardarFormData", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${Cookies.get("token") || ""}`,
        },
      });

      if (response.data && response.data.success) {
        return {
          success: true,
          nombreArchivo: response.data.nombreArchivo || nombreArchivo,
          ruta: response.data.ruta,
        };
      }

      throw new Error("FormData también falló");
    },

    // Generar nombre de archivo
    generarNombreFirma() {
      const timestamp = new Date()
        .toISOString()
        .replace(/[:.-]/g, "")
        .replace("T", "_")
        .substring(0, 15);

      const random = Math.random()
        .toString(36)
        .substring(2, 8);

      // Usar nombre del cliente si existe
      let nombreCliente = "cliente";
      if (this.creditoForm.strNombre) {
        nombreCliente = this.creditoForm.strNombre
          .toLowerCase()
          .replace(/[^a-z0-9áéíóúüñ]/g, "_")
          .substring(0, 20);
      }

      return `firma_${nombreCliente}_${this.localValue.intPOSEnc ||
        "0000"}_${timestamp}_${random}.png`;
    },

    // Convertir base64 a Blob
    base64ToBlob(base64, mimeType) {
      const base64Data = base64.split(",")[1] || base64;
      const byteCharacters = atob(base64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        byteArrays.push(new Uint8Array(byteNumbers));
      }

      return new Blob(byteArrays, { type: mimeType });
    },

    async guardarCredito() {
      try {
        this.loading = true;

        // PASO 1: Obtener firma del canvas
        const firmaBase64 = this.obtenerFirma();

        if (!firmaBase64) {
          alert("La firma es obligatoria");
          return;
        }

        // PASO 2: Guardar firma en servidor (MÉTODO SEPARADO)
        let resultadoFirma = null;
        try {
          resultadoFirma = await this.guardarFirmaEnServidor(firmaBase64);

          if (!resultadoFirma.success) {
            console.warn("⚠️ Firma no se pudo guardar, pero continuamos...");
          }
        } catch (error) {
          console.error("❌ Error en guardar firma:", error);
          resultadoFirma = {
            success: false,
            nombreArchivo: this.generarNombreFirma(),
            error: error.message,
          };
        }
        console.log("INTCONTACTO:  " + this.creditoForm.intContacto);
        // PASO 3: Tu código existente para saldo y prefactura (SIN MODIFICAR)
        const prefactura = {
          intCliente: this.creditoForm.intCliente,
          dblSubtotal: this.credito.monto,
          dblIVA: this.localValue.dblIVA,
          dblTotal: this.credito.monto,
          dblMontoSaldado: 0,
          strNombreFacturacion: this.creditoForm.strNombre,
          intFolio: this.creditoForm.intClave,
          strReferenciaFacturacion: this.creditoForm.strEmail,
          strNumeroExteriorFacturacion: this.creditoForm.strTelefono,
          strConsignatario: this.strGiroComercial,
          intContacto: this.creditoForm.intContacto,
        };

        const saldo = {
          intCliente: this.creditoForm.intCliente,
          intPOSEnc: this.localValue.intPOSEnc,
          intTipoMovimientoSaldo: 2,
          dblMonto: this.localValue.dblTotal,
          intContacto: this.creditoForm.intContacto,
        };

        // Guardar saldo (tu código existente)
        const response1 = await this.encFunctions.savePOSSaldo(saldo);
        console.log("RESPUESTA API SALDO:", response1);

        // Calcular monto saldado
        const saldo1 = this.creditoForm.dblSaldo;
        const total = prefactura.dblTotal;

        if (saldo1 >= 0) {
          prefactura.dblMontoSaldado = 0;
        } else {
          const saldoAFavor = Math.abs(saldo1);
          prefactura.dblMontoSaldado =
            saldoAFavor >= total ? total : saldoAFavor;
        }

        // Guardar prefactura (tu código existente)
        const response = await this.encFunctions.savePrefactura(
          prefactura,
          this.localValue.intPOSEnc
        );
        console.log("RESPUESTA API PREFACTURA:", response);

        // PASO 4: Enviar correo con el NOMBRE DE LA IMAGEN en el payload
        console.log("FIMA ES: ", resultadoFirma.nombreArchivo);
        const payload = {
          para: this.creditoForm.strEmail,
          asunto: this.creditoForm.strNombre,
          html: String(this.credito.monto),
          strNombre: this.creditoForm.strNombre,
          strContacto: this.contactoForm.strNombre,
          strMonto: String(this.credito.monto),
          // SOLO ESTO SE AGREGA: el nombre del archivo de firma
          strFirmaArchivo: resultadoFirma.nombreArchivo,
        };

        console.log("📧 Enviando email con payload:", {
          ...payload,
          strFirmaArchivo: resultadoFirma.nombreArchivo,
        });

        try {
          await axios.post("enviarEmail", payload);
          //console.log("✅ Correo enviado correctamente");
        } catch (error) {
          console.warn("⚠️ Correo NO enviado:", error);
          // No detenemos el proceso por error en email
        }

        // PASO 5: Limpiar y finalizar
        this.dialogPagoCredito = false;
        this.envio_correo.visible = false;

        const obj = {
          propina: this.propina,
          cambio: this.cambio,
          pagos: this.pagos,
          factura: this.requiere_factura,
        };

        this.$emit("pago", obj);
        this.tipoPagoControl = 0;

        // Limpiar formularios
        this.creditoForm = { ...this.creditoFormDefault };
        this.contactoForm = { ...this.contactoFormDefault };

        // Limpiar canvas de firma
        this.limpiarFirma();

        // Mensaje según si se guardó la firma o no
        if (resultadoFirma.success) {
          this.$toast.success(
            `✅ Crédito guardado. Firma: ${resultadoFirma.nombreArchivo}`
          );
        } else {
          this.$toast.warning(
            `⚠️ Crédito guardado, pero la firma no se pudo guardar en el servidor`
          );
        }
      } catch (error) {
        console.error("❌ ERROR AL GUARDAR CRÉDITO:", error);
        this.$toast.error(`Error: ${error.message || error}`);
      } finally {
        this.loading = false;
      }
    },

    async eliminar(pago, index) {
      this.indexSeleccionado = index;
      this.confirm.visible = true;
    },
    async verReservas() {
      this.loading = true;
      try {
        this.reservasActivas = await this.pagoFunctions.getReservas(
          this.session.empresa
        );
        this.reservas.visible = true;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    seleccionaReservacion(reserva) {
      if (reserva.strHabitacion != "") {
        this.referencia = reserva.strHabitacion;
        this.reservacion = reserva.intHotReservacion;
      } else {
        this.referencia = "";
        this.reservacion = 0;
        this.correo = "sincorreo@gmail.com";
        this.$toast.error(
          "La reservacion no tiene habitacion asignada",
          new Toast()
        );
      }
    },
    eliminarAceptado() {
      console.log(this.pagos.splice(this.indexSeleccionado, 1));
      this.pagos.splice(this.indexSeleccionado, 1);
      this.confirm.visible = false;
      console.log("SELECCIONADO: " + this.indexSeleccionado);
    },
    facturaGenerada(facturaGenerada) {
      const obj = {
        propina: this.propina,
        cambio: this.cambio,
        pagos: this.pagos,
        factura: facturaGenerada,
      };
      this.$emit("pago", obj);
    },
    cerrar() {
      this.$emit("cerrar");
    },
  
    async pagar2() {
      const pagoCoDi = this.pagos.find(
        (p) => Number(p.tipoPago.intTipoPago) === 800
      );

      if (pagoCoDi) {
        console.log("SE DETECTO PAGO CODI");

        await this.generarCoDi();

        return;
      }

      if (this.tipoPagoControl === 5000) {
        this.credito.monto = this.totalOrden;
        this.dialogPagoCredito = true;
        return;
      }

      this.envio_correo.visible = false;

      const obj = {
        propina: this.propina,
        cambio: this.cambio,
        pagos: this.pagos,
        factura: this.requiere_factura,
      };

      this.$emit("pago", obj);
    },
    async enviarcorreo() {
      //Enviamos por axios, pero hay que validar que el correo tenga el formato correcto
      this.loading = true;
      try {
        if (
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
            this.correo
          )
        ) {
          //! CAMBIAR
          await axios.get(
            "../../../TootleCFDUIReports/Utilerias/POSLite_Ticket.aspx?action=POS_EnviarTicket&correo=" +
              this.correo +
              "&id=" +
              this.localValue.intPOSEnc
          );
          this.$toast.success("Correo enviado correctamente", new Toast());
        } else {
          throw "El correo no tiene un formato valido, intente de nuevo";
        }
      } catch (e) {
        this.$toast.error(e, new Toast());
      } finally {
        this.loading = false;
      }
    },
    pagar() {
      if (this.envio.activo) this.envio_correo.visible = true;
      else this.pagar2();
    },

    async guardarPago() {

      console.log(this.pagoSeleccionado);
      try {
        //Si ya existe registrado un efectivo entonces ya no guardamos
        const pagoEfectivo = this.pagos.find(
          (pago) =>
            pago.tipoPago.strNombre == "01-CASH" ||
            pago.tipoPago.strNombre == "01-EFECTIVO"
        );
        if (this.pagoSeleccionado.strNombre == "CREDITO") {
          this.tipoPagoControl = 5000;
          console.log("EL TIPO DE PAGO ES CREDITO");
        }

        if (
          pagoEfectivo != null &&
          (this.pagoSeleccionado.strNombre == "01-CASH" ||
            this.pagoSeleccionado.strNombre == "01-EFECTIVO")
        )
          throw "No pueden existir dos pagos en efectivo, favor de modificar el ya existente";

        let efectivo = false;
        if (
          this.pagoSeleccionado.strNombre == "01-CASH" ||
          this.pagoSeleccionado.strNombre == "01-EFECTIVO"
        )
          efectivo = true;

        if (this.mostrar_terminales && this.terminal_seleccionada == null) {
          this.$refs.terminalpago.focus();
          throw "Indique la terminal que utilizara para cobrar";
        }

        if (this.mostrar_prosepago && this.referencia == "") {
          this.$refs.nombre.focus();
          throw "Indique el nombre del titular de la tarjeta";
        }

        if (this.intPOSReferencia == 1 && this.referencia == "") {
          this.$refs.referencia.focus();
          throw "Indique una referencia para poder agregar el pago";
        }
        
        //para lo de CoDi
        console.log("TIPO REAL:", this.pagoSeleccionado.intTipoPago);
        console.log("TYPEOF:", typeof this.pagoSeleccionado.intTipoPago);

        if (Number(this.pagoSeleccionado.intTipoPago) === 8001) {
          await this.generarCoDi();
          return;
        }

        if (
          this.cantidad == 0.0 ||
          this.cantidad == null ||
          this.cantidad == ""
        ) {
          this.$refs.cantidad.focus();
          throw "Indique una cantidad para el tipo de pago";
        }

        if (
          this.mostrar_concepto &&
          this.strConceptoTransaccion == "" &&
          this.mostrar_terminales
        ) {
          this.$refs.strConceptoTransaccion.focus();
          throw "Indique un concepto para poder agregar el pago";
        }
        const totalPago = math.chain(this.cantidad).add(this.pagado);
        //Solo pagos en efectivo pueden exceder

        if (totalPago > this.totalOrden && !efectivo) {
          throw "Verifique su pago a agregar, no puede superar el total de la orden, " +
            this.toMoney(this.totalOrden);
        }

        let terminal = 0;
        if (this.terminal_seleccionada != null) {
          terminal = this.terminal_seleccionada;
        }

        //para efectivo, tarjetas, etc
        this.agregarPago(terminal, totalPago);
      } catch (e) {
        this.$toast.error(e, new Toast());
      }
    },

    agregarPago(terminal, totalPago) {
    const pago = {
      tipoPago: this.pagoSeleccionado,
      cantidad: this.cantidad,
      referencia: this.referencia,
      correo: this.correo,
      terminal_seleccionada: terminal,
      reservacion: this.reservacion,
      strConceptoTransaccion: this.strConceptoTransaccion,
      facturacion: this.facturacion,
};
this.pagos.push(pago);
    const tieneTipoPago5000 = this.pagos.some(
      p => p.tipoPago && p.tipoPago.intTipoPago === 5000
      );
      
      this.tipoPagoControl = tieneTipoPago5000 ? 5000 : 0;
      this.cantidad = math.chain(totalPago).subtract(this.pagado);
      
      this.pagoSeleccionado = null;
      this.referencia = "";
      this.correo = "sincorreo@gmail.com";
      this.reservacion = 0;
      this.strConceptoTransaccion = "";
      this.intPOSReferencia = 0;
      this.terminal_seleccionada = null;
      this.mostrar_terminales = false;
      this.mostrar_prosepago = false;
      this.mostrar_concepto = false;
      
      this.$emit("pago-realizado", { factura: this.factura });
},

    async obtenerTiposPago() {
      const data = new Data();
      const intPOSTipoVenta = this.localValue.intPOSTipoVenta; // Asegúrate de tener localValue definido
      try {
        const tiposPagos = await data.loadTipoPrecio(intPOSTipoVenta);
        console.log(tiposPagos);
        this.tiposPagos = tiposPagos;
        // Maneja los tiposPagos como necesites
      } catch (error) {
        console.error("Error al cargar tipos de pago:", error);
      }
    },
  },
  created() {
    // Llama a obtenerTiposPago cuando el componente es creado
    this.obtenerTiposPago();
  },

  async mounted() {
    this.obtenerTiposPago(); // Asegúrate de que esta función se llame al montar el componente

    this.empresa = Cookies.get("empresaPOS");
    //this.saldoList = await this.getSaldo(this.intCliente);
    let config = this.$config.opciones.find((c) => c.id == 18);
    if (config.valor) {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
    //indica si muestra campo de concepto en transferencias
    // let config_21 = this.$config.opciones.find((c) => c.id == 21)
    if (this.config_21.valor) {
      this.mostrar_concepto = true;
    } else {
      this.mostrar_concepto = false;
    }
  },
};
</script>

<style>
.FacCheck {
  margin: 0px 10px 0px 15px;
  width: 55px;
}

.FacLab {
  font-size: 20px;
}

.firma-canvas {
  border: 5px solid #ccc;
  width: 100%;
  height: 200px;
  touch-action: none;
}
</style>
